import { Link, useNavigate, useSearchParams } from "react-router-dom";
import React, { useState, useContext, useEffect } from 'react';
import "../../assets/css/--component-login.css"
import logoFromBG from "../../assets/images/auth-bg.png";
import { getTimezoneOffset, postRegister } from "../../helper/backend-methods";
import translations from "../../data/language.json"
import { Row, Col } from 'reactstrap'
import { generateKey } from "../../helper/api-methods";
import { UserContext } from "../../context/userContext";
function Register(props) {
    const [searchParams] = useSearchParams();

    const [redirect, setRedirect] = useState(false);
    const [serverError, setServerError] = useState('');
    const [isVisible, setIsVisible] = useState(false)
    const [userfirstname, setUserfirstname] = useState("")
    const [userlastname, setUserlastname] = useState("")
    const [useremail, setUseremail] = useState("")
    const [userphone, setUserphone] = useState("")
    const [usernationality, setUsernationality] = useState(0)
    const [userpassword, setUserpassword] = useState("")
    const [errors, setErrors] = useState({ userfirstname: "", userlastname: "", useremail: "", userphone: "", usernationality: "", userpassword: "", serverError: "" });
    const [loading, setLoading] = useState(false);
    const history = useNavigate();
    const [language, setLanguage] = useState("en")
    const { setUser } = useContext(UserContext);

    
      const normalizePhoneForDB = (value) => {
        const cleaned = value.replace(/\D/g, "");
        
        if (cleaned.length === 10) {
          return `+1${cleaned}`;
        } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
          return `+${cleaned}`;
        } else if (cleaned.length > 11) {
          return `+1${cleaned.slice(-10)}`;
        }
        
        return `+1${cleaned}`;
      };
      

    const validateSubmit = (e) => {
        e.preventDefault();
        const errors = { userfirstname: "", userlastname: "", useremail: "", userphone: "", usernationality: "", userpassword: "" };
        let flag = false;
        if (!userfirstname || userfirstname.replaceAll(/\s/g, '').length < 2) {
            errors.userfirstname = "Your first name is required";
            flag = true;
        }
        if (!userlastname || userlastname.replaceAll(/\s/g, '').length < 2) {
            errors.userlastname = "Your last name is required";
            flag = true;
        }
        if (!useremail || useremail.replaceAll(/\s/g, '').length < 3) {
            errors.useremail = translations.register[language].emailError;
            flag = true;
        }
        else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9-]{2,63}$/i.test(useremail)) {
            errors.useremail = "Please provide a valid email address";
            flag = true;
        }
        if (!userphone || !/^(?:\+1\s?)?(?:\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/.test(userphone)) {
            errors.userphone = "Please provide a valid phone number";
            flag = true;
        }
        if (!userpassword) {
            errors.userpassword = "Please provide a valid password";
            flag = true;
        }
        else if (!/^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?#&]{8,}$/.test(userpassword.trim())) {
            errors.userpassword = "Password must contain at least 1 uppercase letter, 1 number, and be at least 8 characters long";
            flag = true;
        }
        setErrors(errors);
        if (!flag) {
            setLoading(true)
            setServerError('')
            postRegister({ FirstName: userfirstname.trim(), LastName: userlastname.trim(), Email: useremail, Password: userpassword, Phone: normalizePhoneForDB(userphone), Nationality: usernationality ? usernationality : 0, DeviceId: generateKey(true), DeviceName: "Web", Timezone: getTimezoneOffset() }).then(({ data }) => {
                if (data.Status) {
                    localStorage.setItem("authToken", data.Data.Token.Access_Token)
                    localStorage.setItem("userinfo", JSON.stringify(data.Data.UserInfo))
                    setUser(data.Data.UserInfo);
                    if (redirect) {
                        history(redirect);
                    }
                    else {
                        history('/menu');
                    }
                }
                else {
                    setServerError(data.Message);
                    errors.serverError = data.Message;
                    setErrors(errors);
                    setLoading(false)
                }
            }).catch((e) => {
                setServerError(translations.register[language].accountExistsError)
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        const emailFromUrl = searchParams.get("email");
        if (emailFromUrl) {
          setUseremail(decodeURIComponent(emailFromUrl));
        }
      }, [searchParams]);

    return (
        <section id="login">
            <div className="wrapper" style={{ "width": "100%" }}>
                <div className="login-form-wrapper">
                    <div className="login-background">
                        <img src={logoFromBG} alt="" />
                    </div>
                    <form onSubmit={validateSubmit}>
                        {/* <Link to={"/"} className="go-back"><i className="ri-home-4-line"></i></Link> */}
                        {/* <img src={logo} alt="Main Country Grill and Store" className="form-logo" /> */}
                        <h1 className="form-title mb-3 fs-36">Create Your Account</h1>
                        <p className="form-description">Please enter the details to set up your account.</p>
                        {
                            serverError.length ? <p className="text-left txt-danger fs-16 fw-400"><i className="ri-error-warning-line"></i> {errors.serverError}</p> : <></>
                        }
                        <Row>
                            <Col md={6}>
                                <div className="form-group">
                                    <label htmlFor="userfirstname">First Name<span className="txt-danger">*</span></label>
                                    <input id="userfirstname" type="text" className={`rounded-3 ${errors.userfirstname ? "bd-danger" : ""}`} name="userfirstname" onChange={e => /^[A-Za-z\s]*$/.test(e.target.value) && setUserfirstname(e.target.value.slice(0, 25))} value={userfirstname} placeholder={translations.register[language].firstNameLabel} />
                                    {errors.userfirstname ? <span className="txt-danger fs-12 fw-400">{errors.userfirstname}</span> : null}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label htmlFor="userlastname">Last Name<span className="txt-danger">*</span></label>
                                    <input id="userlastname" type="text" className={`rounded-3 ${errors.userlastname ? "bd-danger" : ""}`} name="userlastname" onChange={e => /^[A-Za-z\s]*$/.test(e.target.value) && setUserlastname(e.target.value.slice(0, 25))} value={userlastname} placeholder={translations.register[language].lastNameLabel} />
                                    {errors.userlastname ? <span className="txt-danger fs-12 fw-400">{errors.userlastname}</span> : null}
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="form-group">
                                    <label htmlFor="userphone">Phone<span className="txt-danger">*</span></label>
                                    <input id="userphone text-left"  className={`rounded-3 ${errors.userphone ? "bd-danger" : ""}`} name="userphone" onChange={(e) => { setUserphone(e.target.value) }} value={userphone} placeholder="+1(555) 391-5582" maxLength={16} />
                                    {errors.userphone ? <span className="txt-danger fs-12 fw-400">{errors.userphone}</span> : null}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label htmlFor="useremail">Email<span className="txt-danger">*</span></label>
                                    <input id="useremail" type="email" className={`rounded-3 ${errors.useremail ? "bd-danger" : ""}`} name="useremail" onChange={(e) => { setUseremail(e.target.value.slice(0, 50)) }} value={useremail} placeholder="name@xxx.com" />
                                    {errors.useremail ? <span className="txt-danger fs-12 fw-400">{errors.useremail}</span> : null}
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group has-icon">
                                    <label htmlFor="userpassword">{translations.register[language].passwordLabel}<span className="txt-danger">*</span></label>
                                    <input id="userpassword" type={isVisible ? "text" : "password"} className={`rounded-3 ${errors.userpassword ? "bd-danger" : ""}`} name="userpassword" onChange={(e) => { setUserpassword(e.target.value.replaceAll(/\s/g, '').slice(0, 40)) }} value={userpassword} placeholder="Your Password Here" />
                                    <button onClick={() => { setIsVisible(!isVisible) }} type="button" >{isVisible ? <i className="ri-eye-off-line"></i> : <i className="ri-eye-line"></i>}</button>
                                    <span className="fs-14 fw-400 d-block mt-2 login-info font-inter">Must contain 1 uppercase letter, 1 number, min 8 characters.</span>
                                    {errors.userpassword ? <span className="txt-danger fs-12 fw-400">{errors.userpassword}</span> : null}
                                </div>
                            </Col>
                        </Row>
                        <div className="form-group">
                            <button type="submit" disabled={loading} className="btn btn-primary rounded-5 w-100 border-0">{loading ? "Please Wait..." : "SIGN UP"}</button>
                        </div>

                        <p className="login-info fs-14 font-inter">By clicking Get Started, you agree to accept Main's <Link className="link" to="/terms-and-conditions">Terms & Conditions</Link> and <Link className="link" to="/privacy-policy">Privacy Policy</Link></p>

                        <span className="separator mt-5 mb-4"></span>
                        <div className="form-group mb-0 fs-14 text-gray text-left">
                            Already have an account?
                            <Link to={"/login"} className="link fs-14 ml-2">&nbsp; Log in</Link>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    )
};
export default Register;